'use client';

import { isRichTextEditorEnabled } from '@/constants';

import {
  RichTextPlainFallback,
  RichTextPlateShell,
} from './rich-text-plate-shell';
import type { RichTextInputProps } from './rich-text-shared';

export type RichTextEditorProps = RichTextInputProps;

/** Document-tier markdown editor (job descriptions, long content) — Preview | Markdown switch. */
export function RichTextEditor({
  frame = 'field',
  ...props
}: RichTextEditorProps) {
  if (!isRichTextEditorEnabled()) {
    return <RichTextPlainFallback {...props} chrome="document" frame={frame} />;
  }

  return (
    <RichTextPlateShell
      {...props}
      chrome="document"
      frame={frame}
      defaultMode="preview"
    />
  );
}
